import React, { Component } from "react";
import CategoryPage from "./pages/CategoryPage";
import ProductDescriptionPage from "./pages/ProductDescriptionPage";
import CartPage from "./pages/CartPage";
import Navbar from "./components/Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
export default class App extends Component {
  render() {
    return (
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<CategoryPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route
            path="/product/:productName"
            element={<ProductDescriptionPage />}
          />
          <Route path="/:category" element={<CategoryPage />} />
        </Routes>
      </Router>
    );
  }
}
